import React from 'react'
import allImgPaths from "../../../assets/images";
import { getTimeForChatMessage } from "utils/function";

const PlaceholderLoader = () => {
	return (
		<div className="fete-msg mb-4 last:mb-0 pb-3">
			<div className="w-full flex gap-x-3">
				<img className="w-10 h-10" src="/animated-svg/fetebuddy-animated-icon.svg" alt="" />
				<div>
					<div className="flex items-center gap-x-3 mb-1">
						<span className="text-sm font-interMedium text-[#344054]">Fete Buddy</span>
						<span className="text-xs text-[#475467]">{getTimeForChatMessage(new Date().toISOString())}</span>
					</div>
					<div className="px-3.5 py-2.5">
						<img className="w-10 h-10" src="/animated-svg/fetebuddy-aniated-typing.svg" alt="" />
					</div>
				</div>
			</div>
		</div>
	)
}

export default PlaceholderLoader
